import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#1a1c34',
        secondary: '#212529',
        accent: '#017c65',
        error: '#ff5252',
        // info: '#017c65',
        success: '#017c65',
        warning: '#f8aa00',
        button_primary: '#e50046',
        button_secondary: '#017c65',
        button_white: '#ffffff',
        button_edit: '#017c65',
        button_delete: '#017c65',
        button_rules: '#017c65',
        button_actions: '#017c65',
        button_cancel: '#ffffff'
      },
      dark: {
        primary: '#1a1c34',
        secondary: '#212529',
        accent: '#017c65',
        error: '#ff5252',
        // info: '#017c65',
        success: '#017c65',
        warning: '#f8aa00',
        button_primary: '#e50046',
        button_secondary: '#017c65',
        button_white: '#ffffff',
        button_edit: '#017c65',
        button_delete: '#017c65',
        button_rules: '#017c65',
        button_actions: '#017c65',
        button_cancel: '#ffffff'
      }
    },
    options: {
      cspNonce: 'KSZboG4wfgzCANc4qKBaWWx4G6zbpZOAKk87PByt7Cw=',
      iconfont: 'md'
    }
  }
})
